<template>
  <div>
    <header>
      <h1>Zweispalter tabellarisch</h1>
    </header>
    <div class="tablewrapper">
      <nav class="mainnav">
        <h3>Navigation</h3>
        <ul>
          <li>
            <a href="#">Seite 1</a>
          </li>
          <li>
            <a href="#">Seite 2</a>
          </li>
          <li>
            <a href="#">Seite 3</a>
          </li>
          <li>
            <a href="#">Seite 4</a>
          </li>
          <li>
            <a href="#">Seite 5</a>
          </li>
        </ul>
      </nav>
      <section class="maincontent">
        <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>
        <h2>Unterüberschrift H2</h2>
        <p>Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p>
      </section>
    </div>
    <footer>Zweispalter mit float</footer>
  </div>
</template>

<script>
export default {
  name: "Zweispalter-FloatView",
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
  header, .tablewrapper, footer {
    min-width: 240px;
  }
header {
  background-color: darkkhaki;
}
h1 {
  text-align: center;
  padding: 10px;
  background-color: tomato;
  margin: 0px;
}

.mainnav {
  box-sizing: border-box;
  margin: 0;
  padding: 0 10px;
  border: 0;
  background-color: darkgrey;
}

.mainnav h3,
.mainnav ul {
  margin: 0.3em;
  list-style: none;
}

.mainnav h3 {
  margin: 0px;
}
.mainnav ul {
  margin-bottom: 0;
  padding-left: 0.3em;
}

.mainnav li {
  margin: 0.4em 0;
  padding: 0.2em;
  border: 1px solid gray;
  text-align: center;
}

.maincontent {
  box-sizing: border-box;
  margin: 0;
  padding: 0 20px;
  border: 0;
  background-color: cyan;
}

footer {
  clear: both;
  background-color: rgb(236, 206, 206);
}
@media only screen and (min-width: 660px) {
  .mainnav ul {
    display: table;
    width: 100%;
  }
  .mainnav li {
    display: table-cell;
    width: 20%;
    vertical-align: middle;
  }
}

@media only screen and (min-width: 800px) {
  header, .tablewrapper, footer {
            max-width: 1300px;
            box-sizing: border-box;
         }
  .tablewrapper {
    display: table;
  }

  .mainnav {
    display: table-cell;
    width: 40%;
  }
  .mainnav li {
    display: list-item;
    width: auto;
  }

  .maincontent {
    display: table-cell;
    width: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/css-examples/zweispalter-table.vue